function AlarmChartFrame() {
    /// <summary>
    /// This object provides common functions for the Widget.Events.AlarmChartFrame. <br/>
    /// Author: ARF<br />
    /// Date: 30.9.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 1.10.2019                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bInit = false;
    
}
AlarmChartFrame.prototype = new vcTemplate();

AlarmChartFrame.prototype.init = function () {
    /// <summary>
    /// This function inits the calendar, the left menu and sets some heights.
    /// </summary>
    var me = this;
    var w, h;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
        w = me.width;
        w = w - parseInt(me.visual.find("#div-menu").width()) - 18;
        me.visual.find("#div-chart-content").width(w);
       
        me.visual.find("#div-calendar").vcDateBox({
            mode: 'Single', align: 'left', interval: 1, defaultDate: me.date, langID: me.userLangIDForCulture, callback:
            function(obj) {
                if (me.bInit === false) {
                    h = me.height;
                    h = h - parseInt(me.visual.find("#div-top").height()) - 12;
                    
                    me.visual.find("#div-menu,#ul-menu, #div-chart-content").height(h);
                    me.bInit = true;
                } else {
                    me.date = obj.returnDates.from;
                  
                    me.showChart();
                }
            }
        });

        me.visual.find("#div-menu .vc-list-item").off("click").on("click",
            function () {
                me.visual.find("#div-menu .vc-list-item").removeClass("selected");
                $(this).addClass("selected");
                me.showChart($(this));
            });


        me.showChart();
    
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};



//inits the alarm chart
AlarmChartFrame.prototype.showChart = function () {
    /// <summary>
    /// This function shows some charts based on the given funct index.
    /// </summary>
  var me = this;
    var param = {};
    var obj;
    var functIndex = -1;
    try {
     
        obj = me.visual.find("#div-menu .vc-list-item.selected");
        functIndex = parseInt(obj.data("index"));

        me.visual.find("#div-chart-content").html("");

        //show the alarm chart
        if (functIndex >= 0) {
            me.container1 = me.getRandomIDContainerObj("div-chart-content-", true);
            me.visual.find("#div-chart-content").html(me.container1.obj);
            me.container1.obj.css("width", "100%");
            me.container1.obj.html(me.vcC.getLoadingIcon());

            param.AlarmID = me.aid;
            param.DataType = me.dataType;
            param.FunctIndex = functIndex;

            me.vcVisual.addVisualBaseByName('div-chart-content-',"VISUAL_CHART_HR_ALARM",me.container1.random,me.date,parseInt(me.visual.find("#div-chart-content").height()),
                parseInt(me.visual.find("#div-chart-content").width()),JSON.stringify(param),'',me.deviceType);

        } else {

            me.visual.find("#div-chart-content").html($("<div>").attr("id", "div-trend-main")).append($("<div>").attr("id", "div-trend-sub"));
            
            if (me.bsdids === null) {
                me.visual.find("#div-trend-sub").hide();

            } else {
                var h = parseInt(me.visual.find("#div-chart-content").height());
                h = h - me.visual.find("#div-trend-main").height() - 18;
                me.visual.find("#div-trend-sub").height(h);
            }

            me.container2 = me.getRandomIDContainerObj("div-trend-main-", true);
            me.visual.find("#div-trend-main").html(me.container2.obj);
            me.container2.obj.css("width", "100%");
            me.container2.obj.html(me.vcC.getLoadingIcon());
           
            me.vcVisual.addVisualBaseByName('div-trend-main-', "VISUAL_DIGITALTREND", me.container2.random, me.date, parseInt(me.visual.find("#div-trend-main").height()),
                parseInt(me.visual.find("#div-trend-main").width()),
                '', JSON.stringify({ 'DigitalTrendType': 5, "BSDID": me.aid }),me.deviceType);

            //if we have some digital signals set as well - we show them
            if (me.bsdids !== null) {
                var content = $("<div>").attr("id", "div-trend1-sub1").width(w).height(h - 30);
                var w = parseInt(me.visual.find("#div-chart-content").width());
                var h = parseInt(me.visual.find("#div-chart-content").height());

                if (me.isEmax) {

                    var btnTrend = $("<div>").addClass("button-toggle button-toggle-active").html(me.digitalSignals).button().off("click").on("click", function () {
                        me.visual.find("#div-chart-content .button-toggle").removeClass("button-toggle-active");
                        btnTrend.addClass("button-toggle-active");
                        me.vcVisual.addVisualBaseByName('div-trend1-', "VISUAL_DIGITALTREND", "sub1", me.date, h - 30, w, '', JSON.stringify({ 'DigitalTrendType': 4, "BSDID": me.bsdids }), me.deviceType);
                    });

                    var btnProtocol = $("<div>").addClass("button-toggle").html(me.protocol).button().off("click").on("click", function () {
                        me.visual.find("#div-chart-content .button-toggle").removeClass("button-toggle-active");
                        btnProtocol.addClass("button-toggle-active");
                        content.EmaxProtocolList({ invokeType: "addVisualBase", parameter: { Aid: me.aid } });
                    });

                  
                    me.visual.find("#div-trend-sub").html(btnTrend).append(btnProtocol).append(content);

                    me.vcVisual.addVisualBaseByName('div-trend1-', "VISUAL_DIGITALTREND", "sub1", me.date, h-30, w, '', JSON.stringify({ 'DigitalTrendType': 4, "BSDID": me.bsdids }), me.deviceType);

                } else {

                  
                    me.vcVisual.addVisualBaseByName('div-trend-', "VISUAL_DIGITALTREND", "sub", me.date, h, w, '', JSON.stringify({ 'DigitalTrendType': 4, "BSDID": me.bsdids }), me.deviceType);

                }


            }






        }

        return true;
    } catch (ex) { me.writeError("showChart", ex); return false;}
};




AlarmChartFrame.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-menu', "#div-chart-content").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


AlarmChartFrame.prototype.writeError = function (source, ex) {
    var me = this;
    try {
         console.info(ex);
        me.error = true;
        me.showMessage(me.resources.err_code, true);
        writeError(me.source + ".JS." + source, ex);
        return false;
    } catch (ex) {
        me.error = true;
        writeError(me.source + '.JS.writeError', ex);
        return false;
    }
};

